import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTabReferencia = '/service/contabilidade/administracaoRH/'

class ReferenciaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getReferencia() {
        return this.conex.get(urlTabReferencia + 'retornaTodosReferencia/')
    }
}

export default ReferenciaService
